import * as React from "react"

const ContactLocation = ({ className }) => {
  return (
    <section className={className}>
      <div className={"max-w-6xl mx-auto"}>
        <div className={"px-6 md:px-4"}>
          <div className={"w-full grid md:grid-cols-12 gap-4 md:gap-8"}>
            <div className={"md:col-span-2"}>
              <h3 className={"text-xl text-navy font-bold mb-4"}>
                How To Find Us
              </h3>
              <address className={"not-italic"}>
                Unit 14,
                <br />
                Alston Road,
                <br />
                Hellesdon Park Industrial Estate
                <br />
                Norwich
                <br />
                NR6 5DS
              </address>
            </div>

            <div className={"md:col-span-6 bg-grey-200"}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2420.4914643614056!2d1.253060716057873!3d52.6511000342572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d9e10a2ac8b233%3A0x2787aa3c85126953!2sNorfolk%20Trailers!5e0!3m2!1sen!2suk!4v1668008214176!5m2!1sen!2suk"
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={"google-map"}
              ></iframe>
            </div>

            <div className={"md:col-span-4"}>
              <h3 className={"text-xl text-navy font-bold mb-4"}>
                Showroom Opening Times
              </h3>

              <p>
                <span className={"text-navy font-bold"}>Monday - Friday</span>
                <br />
                8:00 am - 5:00pm
                <br />
                <br />
                <span className={"text-navy font-bold"}>Saturday</span>
                <br />
                8:30am - 12:00pm
                <br />
                <br />
                <span className={"text-navy font-bold"}>Sunday</span>
                <br />
                Closed
                <br />
                <br />
                Appointments out of hours are available upon request.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactLocation
